import { Map, Record, List } from "immutable";

import { LOADING_STATE } from "@typings/reduxThunkActions";
import { ContractToPauseDto } from "@typings/contracts";

export enum AGENT_COMPENSATION_TYPE {
  FULL = "full",
  ONE_HOUR = "one_hour",
  CUSTOM_AMOUNT = "custom_amount",
}

export type HolidayAction = "MOVE" | "DELETE";

export interface HolidayBase {
  startDate: string;
  endDate: string;
  skipCleanings: boolean;
  compensateAgent: boolean;
  pauseCleanings: boolean;
  actions: HolidayAction[];
}

export interface Holiday extends HolidayBase {
  id: string;
  visible: boolean;
  agentCompensationAmount: number;
  agentCompensationType?: AGENT_COMPENSATION_TYPE;
  calendarStartDate?: string;
}

export type Holidays = Map<string, Record<Holiday>>;

export type HolidayReducer = Record<{
  holidays: Holidays;
  processedHoliday: Record<Holiday> | null;
  loadingState: LOADING_STATE;
  contractsToPause: List<ContractToPauseDto>;
}>;

export {};
